import { privacy } from './privacy';
import { cookies } from './cookies';
import { imprint } from './imprint';
import { terms } from './terms';
import { survey } from './survey';

export const en = {
  // Navigation
  nav: {
    home: 'Home',
    about: 'About',
    discover: 'Discover',
    team: 'Team',
    gallery: 'Gallery',
    pricing: 'Pricing',
    blog: 'Blog',
    contact: 'Contact',
    survey: 'Doctors Survey',
  },

  // Hero Section
  hero: {
    mainTitle: 'Join TerminTeiler: Share Slots, Build Care!',
    subtitle: 'TerminTeiler empowers patients to pass on unused appointments, reducing wait times and optimizing care. Together, we build a fairer, more sustainable healthcare future.',
    learnMoreButton: 'Learn More',
  },

  // Iconbox Section
  iconbox: {
    shareAppointments: {
      title: 'Share Appointments Easily',
      subtitle: 'Empower others by passing on unused slots with a simple, secure process.',
    },
    realTimeAvailability: {
      title: 'Real-Time Availability',
      subtitle: 'Access short-notice appointments instantly with real-time notifications.',
    },
    supportWhenNeeded: {
      title: 'Support When Needed',
      subtitle: 'Get faster care by claiming shared slots, especially in emergencies.',
    },
  },


  // Team Section
  team: {
    feryal: {
      name: 'Feryal Catoglu',
      designation: 'Founder & Visionary',
    },
    faheem: {
      name: 'Faheem Babar',
      designation: 'Co-Founder & Project Manager',
    },
    haitham: {
      name: 'Haitham El Euch',
      designation: 'Co-Founder & Software Developer',
    },
    jouhaina: {
      name: 'Jouhaina Salsabil El Euch',
      designation: 'Co-Founder & Software Developer',
    },
  },

  // Team Section Data
  teamSectionData: {
    title: 'Meet Our TerminTeiler Team',
    subTitle: 'Discover the dedicated professionals driving TerminTeiler’s 2025 Siegen pilot. <br /> Together, we’re transforming healthcare access across Germany!'
  },

  // Testimonials
  testimonials: {
    ralph: {
      name: 'Shahbaz Chattha',
      designation: 'CEO, Smahh',
      quote: "I'm amazed by the Termin Teiler concept! Sharing unused appointments is a brilliant way to cut wait times.",
      extraQuote: "Solidarity in healthcare is the future!",
    },
    francis: {
      name: 'Adeel Akram',
      designation: 'Biographer',
      quote: "TerminTeiler's idea is revolutionary. It saved me weeks of waiting and brought a sense of community. Great execution!",
      extraQuote: "A game-changer for busy professionals.",
    },
    david: {
      name: 'Amna Sabir',
      designation: 'UX Designer',
      quote: "The platform's ease of use and the innovative idea behind TerminTeiler deserve applause. It's a lifeline for patients!",
      extraQuote: "Design meets purpose perfectly here.",
    },
  },

  // Pricing Section
  pricing: {
    bloodTest: 'Blood Test',
    hemoglobinTest: 'Hemoglobin Test',
    homocysteineTest: 'Homocysteine Test',
    firstDescription: 'First Description',
    secondDescription: 'Second Description',
    thirdDescription: 'Third Description',
    fourthDescription: 'Fourth Description',
    fifthDescription: 'Fifth Description',
  },

  // FAQ Section
  faq: {
    title: 'Frequently Asked Questions',
    questions: {
      whatIsTerminTeiler: {
        title: 'What is TerminTeiler?',
        content: 'TerminTeiler is an innovative digital platform that enables patients in Germany to anonymously and voluntarily share unused or canceled doctor\'s appointments with others in need. It addresses long waiting times for specialists by optimizing existing slots without additional burden on medical practices.',
      },
      howDoesItWork: {
        title: 'How does TerminTeiler work?',
        content: 'When an appointment is booked, the doctor’s office directly enters it into TerminTeiler. Patients can view the appointment in their personal dashboard and decide whether to keep or share it. Released appointments become visible through radius filtering and real-time notifications, allowing nearby users to quickly claim them. The process complies with data protection regulations and promotes a fair distribution of available appointments.'
      },
      whoCanUse: {
        title: 'Who can use TerminTeiler?',
        content: 'The platform is open to all patients, including working professionals, parents, seniors, and caregivers. It supports sharing for dependents like children or elderly relatives and extends to high-demand areas such as pediatricians, midwives, rehab, or addiction clinics.',
      },
      isItSecure: {
        title: 'Is TerminTeiler secure and compliant with data protection?',
        content: 'Yes, TerminTeiler is fully DSGVO-compliant. Appointments are shared anonymously, with no health data stored. Features include identity verification via registration, automatic deletion after transfer, and practice dashboards for oversight to prevent misuse.',
      },
      unclaimedAppointment: {
        title: 'What happens if no one claims my released appointment?',
        content: 'If unclaimed within the countdown window, the slot automatically returns to the doctor\'s schedule as a fallback option. This ensures no disruption to practices while maximizing sharing opportunities.',
      },
      practicesInsurers: {
        title: 'Can practices or insurers get involved?',
        content: 'Absolutely! Practices receive their own dashboard view, enabling easy management and tracking. TerminTeiler is seeking non-commercial partnerships within the framework of licensing. For cooperation inquiries, please contact Feryal Catoglu at info@terminteiler.com',
      },
      whenWillLaunch: {
        title: 'When will TerminTeiler launch?',
        content: 'We are currently in the development phase and planning a pilot operation in 3–5 cities, starting in Siegen. The test phase will last approximately 6–12 months. Support our project by signing the change.org/start-a-petition and stay informed via www.terminteiler.de. We are also looking for interested investors and partners to help enable the nationwide launch.',
      },
      ideaProtection: {
        title: 'How is the TerminTeiler idea protected?',
        content: 'The "TerminTeiler" trademark is filed at the DPMA (April 2025), with full copyright protection under §§ 2, 7 UrhG. Unauthorized use or commercialization is prohibited—exclusive licensing ensures quality control.',
      },
    },
  },



  // Department Section
  department: {
    title: 'Discover TerminTeiler',
    subtitle: 'Explore the key aspects of TerminTeiler, the innovative platform for sharing doctor\'s appointments in Germany. Reducing wait times and optimizing healthcare through solidarity.',
    tabs: {
      origin: 'Origin',
      overview: 'Overview',
      digital: 'Digital',
      // community: 'Community',
      legal: 'Legal',
      future: 'Future',
    },
    content: {
      origin: {
        title: 'How It All Began: The Origin of the Idea',
        subtitle: 'From a personal experience to a revolutionary concept.',
        text: 'The idea for TerminTeiler originated from Feryal Catoglu\'s personal encounter where she wanted to pass on an unused orthopedic appointment to someone in need. This moment highlighted the widespread issue of long waiting times in Germany\'s healthcare system, sparking a vision for a platform where patients can share canceled appointments directly. Driven by solidarity and efficiency, TerminTeiler aims to make healthcare more accessible without burdening medical practices.',
      },
      overview: {
        title: 'Project Overview',
        subtitle: 'Understanding TerminTeiler\'s core idea and benefits.',
        text: 'TerminTeiler is a digital platform that enables patients to anonymously share unused doctor’s appointments. It is primarily aimed at groups such as working professionals, parents, and seniors, but is fundamentally intended for all users. The platform helps significantly reduce waiting times, use healthcare resources more efficiently, and promote sustainability through paperless processes. TerminTeiler works in close cooperation with health insurers and follows a non-commercial approach.',
        readMore: 'Read More',
      },
      digital: {
        title: 'Digital Functions',
        subtitle: 'Innovative tools for seamless appointment sharing.',
        text: 'TerminTeiler offers real-time features such as countdown windows for quick claims, notifications for all parties, radius-based filtering (10–30 km), bell alerts for matching slots, favorites for preferred practices, and messaging with practices. It is fully digital and paperless, promoting sustainability while focusing on short-term appointments and fallback options for unclaimed slots.',
        readMore: 'Read More',
      },
      // community: {
      //   title: 'Community Approach',
      //   subtitle: 'Building trust through rewards and engagement.',
      //   text: 'The community aspect includes a points system for responsible behavior, such as timely releases, fostering a trust ranking similar to ride-sharing apps. It integrates with corporate health programs (BGM) and health insurers for bonuses like workshops or events, emphasizing rewards over punishment to encourage solidarity and fair usage.',
      //   readMore: 'Read More',
      // },
      legal: {
        title: 'Legal Aspects',
        subtitle: 'Ensuring security, compliance, and protection.',
        text: 'TerminTeiler prioritizes control with practice dashboards for oversight, automated deletions post-transfer, binding patient declarations, and registration for identity verification. The licensing model is non-commercial, with exclusive partnerships and a premium version for private insurers. The idea is protected by trademark at DPMA, copyright, and prohibits unauthorized use.',
        readMore: 'Read More',
      },
      future: {
        title: 'Future Vision',
        subtitle: 'Expanding beyond traditional appointments.',
        text: 'Looking ahead, TerminTeiler plans a 6–12 month pilot in 3–5 cities, measuring success through transferred appointments and user satisfaction. Broader adoption could lead to significant long-term cost savings in the healthcare sector. Future expansions include AI-based predictions, non-medical uses such as rehabilitation or sports, and extended licenses for quality control to ensure sustainable growth.',
        readMore: 'Read More',
      },
    },
  },

  // About Section
  about: {
    title: 'Revolutionizing Healthcare with TerminTeiler',
    subtitle: 'TerminTeiler, founded by Feryal Catoglu and Faheem Babar, redefines healthcare access in Germany by enabling patients to share unused appointments. Tackling the 200 million wasted slots annually, we reduce wait times and optimize care through a community-driven platform. With AI-powered matching, a points-based trust system, and partnerships with insurers and medical networks, we create a sustainable, equitable healthcare future.',
    founder: {
      name: 'Faheem Babar Chattha',
      designation: 'Founder',
    },
    highlights: [
      'Reduces 200M+ wasted appointments yearly',
      'Cuts wait times by up to 30 days for specialists',
      'Empowers 18M patients with faster access',
      'Promotes sustainable, paperless healthcare',
    ],
    contact: '+49 152 38556881',
    sectionTitle: 'Who We Are',
    sectionSubtitle: 'TerminTeiler is a pioneering initiative transforming healthcare access in Germany. Discover a platform built on solidarity and innovation.',
    impactTitle: 'Impact Highlights',
    getInTouch: 'Get in Touch',
    showMore: 'Meet Our Team',
    showLess: 'Show Less',
  },

  // Contact Section
  contact: {
    title: 'Get in Touch with TerminTeiler',
    subtitle: 'Support our 2025 pilot launch in Siegen or share feedback. Let\'s improve healthcare access together!',
    form: {
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter your full name',
      email: 'Email Address',
      emailPlaceholder: 'your.email@example.com',
      subject: 'Subject',
      subjectPlaceholder: 'e.g., Pilot Support or Feedback',
      phone: 'Phone',
      phonePlaceholder: '+49 152 38556881',
      message: 'Your Message',
      messagePlaceholder: 'Share your thoughts or questions about TerminTeiler...',
      sendButton: 'Send Message',
      sendingButton: 'Sending...',
      successMessage: 'Thank you! Your message has been sent. We\'ll get back to you soon.',
      errorMessage: 'Oops! Something went wrong. Please try again.',
    },
  },

  // Funfact Section
  funfact: {
    title: 'Goals After One Year of Launch',
    stats: {
      appointmentsShared: 'Appointments Shared',
      registeredUsers: 'Registered Users',
      successfulTransfers: 'Successful Transfers',
      citiesCovered: 'Cities Covered',
    },
  },


  // What People say
  whatPeopleSays: {
    title: 'What people say?',
    subTitle: 'Explore feedback on TerminTeiler, revolutionizing healthcare appointment sharing in Germany. <br /> Hear real stories of solidarity and efficiency.'
  },

  // Newsletter Section
  newsletter: {
    title: 'Stay Connected with Termin Teiler',
    subtitle: 'Subscribe to our newsletter for the latest updates on the Termin Teiler pilot launch in 2025, community events, and exclusive insights into appointment sharing innovations.',
    emailPlaceholder: 'Enter Your Email Address',
    successMessage: 'Thank you for subscribing! Check your inbox for confirmation.',
    errorMessage: 'Oops! Something went wrong. Please try again.',
    whatsappText: 'Chat with us on WhatsApp',
  },

  // Footer Section
  footer: {
    subTitle: 'Empower healthcare equity with TerminTeiler! Launched in 2025, our mission is to connect patients in Germany, starting with the Siegen pilot, to share appointments and transform care access by October 2025.',
    usefulLinks: 'Useful Links',
    legalLinks: 'Legal',
    contacts: 'Contacts',
    address: 'Address:',
    addressLine: 'Sandstraße 26, 57072 Siegen, Germany',
    email: 'Email:',
    phone: 'Phone:',
    copyright: 'Copyright {year}. By TerminTeiler',
    links: {
      faqs: 'FAQs',
      blog: 'Blog',
      timetable: 'Weekly Timetable',
      terms: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      cookieSettings: 'Cookie Settings',
      imprint: 'Imprint',
      termsConditions: 'Terms & Conditions',
    },
  },

  // Brands Section
  brands: {
    title: 'Our Sponsors',
    subtitle: 'Supporting organizations that share our vision for better healthcare access',
  },

  // Language Switcher
  language: {
    english: 'English',
    german: 'Deutsch',
    selectLanguage: 'Select Language',
  },

  // SEO
  seo: {
    siteName: 'TerminTeiler',
    defaultTitle: 'TerminTeiler - Share Doctor Appointments | Reduce Waiting Times',
    defaultDescription: 'TerminTeiler empowers patients to share unused appointments, reduce waiting times, and optimize healthcare. Together we build a fairer, more sustainable healthcare future.',
    home: {
      title: 'TerminTeiler - Share Doctor Appointments | Reduce Waiting Times',
      description: 'TerminTeiler empowers patients to share unused appointments, reduce waiting times, and optimize healthcare. Together we build a fairer, more sustainable healthcare future.',
      keywords: 'doctor appointment, share appointment, healthcare, reduce waiting times, Germany, appointment sharing, appointment mediation',
    },
  },

  // Privacy Policy
  privacy,

  // Cookie Policy
  cookies,

  // Imprint
  imprint,

  // Terms and Conditions
  terms,

  // Survey
  survey,
};
